<div class="navbar__container container">
  <div class="navbar__menu row flex-nowrap">
    <a (click)="scrollToSection('jobs')" class="navbar__menu-link">NICE JOBS</a>

    <a (click)="scrollToSection('why')" class="navbar__menu-link"
      >WHY NICE PROJECT</a
    >
    <a (click)="scrollToSection('perks')" class="navbar__menu-link"
      >PERKS AND BENEFITS</a
    >
    <a (click)="scrollToSection('recruitment')" class="navbar__menu-link"
      >RECRUITMENT PROCESS</a
    >

    <span class="navbar__menu-gradient"></span>
  </div>
</div>
